import ServicesList from '../../components/ServicesList/ServicesList'

export default function Services(){
    return (
        <>
            <ServicesList url="service"/>
        </>
    )
}